import {isAssetRestricted} from './assetHelper';

export function isAllAssetsUncured(data = []) {
  return !data.some(item => item.isCured);
}

export function isAllAssetsUnrestricted(data = []) {
  return !data.some(item => isAssetRestricted(item));
}

